<div class="row ss-top-menu">
  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
    <span class="ss-text-light addCursor" routerLink="/">Dashboard <i class="rightArrow fa fa-angle-right"></i></span>
    <span class="ss-text-dark">Leads <i class="rightArrow fa fa-angle-right"></i></span> <span class="capitalize ss-text-dark">{{customer_status  | replaceChar}}</span>
  </div>
  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
    <div class="ss-searchbox">
      <i class="fa fa-search"></i>
      <input class="form-control" type="text" placeholder="Type in name, contact, status, role, date, designer to search..." #search (keyup.enter)="onKey($event)">
    </div>
  </div>

  <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-xs-5 mt-2">
    <a class="addCursor downloadBtn" (click)="smartShareEmail()">Download Smartshare Report</a>
    <a class="addCursor downloadBtn ml-2" (click)="downloadExcel()">Download Lead</a>
  </div>

  
</div>

<div class="row">
    <div class="col-12" *ngIf="successalert">
      <div class="alert-box grid-100" *ngIf="successMessage">
        <div class="alert alert-success mt-3 text-center">
            <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
            {{successMessage}}
          </div>
      </div>
    </div>
   <div class="rk-ui-notification err" *ngIf="erroralert">
    <span id="notificationMessageText">{{errorMessage}}</span>
    <a class="close rk-linknotification" (click)="erroralert=false">×</a>
  </div>
</div>
<div class="row justify-content-end">
  <div class="col-12 my-2">
    <div class="filterDiv pull-right">
      <p class="d-inline-block m-0">Filter By - </p>
      <select class="filterSelect" (change)="filterColumDropdownChange($event.target.value)" [(ngModel)]="filtercol1Val" id="filter1dropdown">
        <!-- <option value="" disabled>Select Column</option> -->
        <option value="all" selected><span class="capitalize">All</span></option>
        <option value="lead_created_at"><span class="capitalize">Lead Acquisition Date</span></option>
        <option value="assigned_to_cm"><span class="capitalize">CM Assignment Date</span></option>
        <option value="assigned_to_designer"><span class="capitalize">Designer Assignment Date</span></option>
      </select>
      <div style="display: none;" id="fromDateFilter"><label class="ml-2 mr-2">From Date</label><input type="date" name="" [(ngModel)]="fromDateFilter">
      </div>
      <div style="display: none;" id="toDateFilter"><label class="ml-2 mr-2">To Date</label><input type="date" name="" [(ngModel)]="toDateFilter" [min]="fromDateFilter"></div>
      <button class="filterBtn" (click)="filterSubmit()">GO</button>
    </div>


  </div>
</div>


<div class="row my-4 lappyView">
  <div class="col-md-12">
    <div class="tableDiv table-responsive">
      <p class="text-center" *ngIf="usersList &&  usersList.length==0 ">No Leads</p>
      <table class="table" *ngIf="usersList &&  usersList.length>0">
        <thead>
          <tr>
            <th class="text-center firstTh">#</th>
            
            <th>
              NAME
              <i class="fa ml-2 fa-sort" *ngIf="column != 'name'" (click)="sortFunc(usersList,{property: 'name', direction: '1'})"></i><i class="fa ml-2 fa-sort-asc" *ngIf="column == 'name' && direction=='1' " (click)="sortFunc(usersList,{property: 'name', direction: '-1'})"></i><i class="fa ml-2 fa-sort-desc" *ngIf="column == 'name' && direction=='-1' " (click)="sortFunc(usersList,{property: 'name', direction: '1'})"></i>
            </th>
            <th></th>
            <th>
              LEAD ID
              <i class="fa ml-2 fa-sort" *ngIf="column != 'id'" (click)="sortFunc(usersList,{property: 'id', direction: '1'})"></i><i class="fa ml-2 fa-sort-asc" *ngIf="column == 'id' && direction=='1' " (click)="sortFunc(usersList,{property: 'id', direction: '-1'})"></i><i class="fa ml-2 fa-sort-desc" *ngIf="column == 'id' && direction=='-1' " (click)="sortFunc(usersList,{property: 'id', direction: '1'})"></i>
            </th>
          <!--   <th (click)="sort('designer_assignement_date')">LEAD ASSIGNMENT DATE <i class="fa ml-2" [ngClass]="{'fa-sort': column != 'designer_assignement_date', 'fa-sort-asc': (column == 'designer_assignement_date' && !isDesc), 'fa-sort-desc': (column == 'designer_assignement_date' && isDesc) }" aria-hidden="true"></i></th> -->
            <th style="min-width: 12rem;">LEAD ASSIGNED 
               <i class="fa ml-2 fa-sort" *ngIf="column != 'designer_assignement_date'" (click)="sortFunc(usersList,{property: 'designer_assignement_date', direction: '1'})"></i><i class="fa ml-2 fa-sort-asc" *ngIf="column == 'designer_assignement_date' && direction=='1' " (click)="sortFunc(usersList,{property: 'designer_assignement_date', direction: '-1'})"></i><i class="fa ml-2 fa-sort-desc" *ngIf="column == 'designer_assignement_date' && direction=='-1' " (click)="sortFunc(usersList,{property: 'designer_assignement_date', direction: '1'})"></i>
            </th>
            <th>REFERRAL PARTNER</th>
            <th>LEAD STORE</th>
            <th style="min-width: 160px;">CURRENT STATUS</th>
            <th *ngIf="customer_status!='lost' ">CHANGE STATUS</th>
            <th *ngIf="customer_status=='lost' ">Reason For Lost</th>
            <th *ngIf="(customer_status=='follow_up' || customer_status=='lost') ">Remarks</th>
            <th class="minWidthForTd">REFERRAL TYPE</th>
            <th> </th>
            <th class="lastTh"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of usersList | paginate: { itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  } ; let i = index; " [attr.data-index]="i" id="filteredLeadRow{{i}}">
            <td class="text-center">{{((current_page-1) * per_page) + (i+1)}}</td>
              <td>
                <span class="ss-link cursor-pointer" routerLink="/lead/{{data.id}}/activity-logs">{{data.name}}</span>
              </td>
              <td><a href="https://office.arrivae.com/delta/designer/{{data.lead_details.related_user_id}}/{{designerId}}" target="_blank" class="btn btn-pink ml-2">Smart Share</a>
              </td>
              <td *ngIf="data.lead_details!=null">{{data.lead_details.id}}</td>

              <td>
                {{data.designer_assignement_date | date: 'dd/MM/yyyy - h:mm a'}}<br>
              </td>
              <td>{{ data.referal_partner_name |  replaceChar}}</td>
              <td class="capitalize"><span *ngIf="data.lead_store">{{ data.lead_store.name}}</span></td>
              <td class="capitalize">
                <ng-container *ngIf="(data.project_details.status!='follow_up' && data.project_details.status!='lost' && data.project_details.status !='not_contactable')">{{data.project_details.status | replaceChar}} 
                </ng-container>
                <ng-container *ngIf="(data.project_details.status =='not_contactable' )">{{data.project_details.status | replaceChar}} 
                <p class="time-chng">{{data.event_scheduled_at.follow_up_for_not_contactable | date:'dd/MM/yyyy - h:mm a'}}</p>
                </ng-container>
                <ng-container *ngIf="(data.project_details.status =='delayed_possession' || data.project_details.status =='delayed_project')">{{data.project_details.status | replaceChar}} 
                <p class="time-chng">Date:-({{data.delayed_date}})</p>
                </ng-container>
                <ng-container *ngIf="(data.project_details.status=='follow_up')">
                    <a data-trigger="hover" title="Remarks" [attr.data-content] ="data.project_details.remarks" class="pop" (mouseenter)="openpopup($event)">{{data.project_details.status | replaceChar}}</a>
                    <p class="time-chng">{{data.event_scheduled_at.follow_up | date:'dd/MM/yyyy - h:mm a'}}</p>
                </ng-container>
                <ng-container *ngIf="(data.project_details.status=='lost')">
                    <a data-trigger="hover" title="Remarks" [attr.data-content] ="data.project_details.remarks | replaceChar " class="pop" (mouseenter)="openpopup($event)">{{data.project_details.status | replaceChar}}</a>
                </ng-container>
                <br>
                <a class="addCursor text-primary" (click)="smartShareHistory(data.lead_details.id)" data-toggle="modal" data-target="#smartShareHistory">Smartshare  History</a>
              </td>
              <td *ngIf="customer_status!='lost' ">
                <select (change) = "onStatusChange(data.project_details.user_id,data.project_details.id, $event.target.value)" class="custom-select" >
                  <option>Change Status</option>
                  <!-- <option value="lost" >Lost</option> -->
                  <option value="not_contactable" >Not Contactable</option>
                  <option value="follow_up" >Follow Up</option>
                  <option value="wip" >WIP</option>
                  <option value="delayed_possession">Delayed Possession</option>
                  <option value="delayed_project">Delayed Project</option>
                </select>
              </td>
              <td *ngIf="customer_status=='lost' " class="capitalize">{{data.project_details.reason_for_lost | replaceChar}}</td>
              <td *ngIf="(customer_status=='follow_up' || customer_status=='lost') ">{{data.customer_remarks}}</td>
              <td>
                {{data.lead_details.referrer_type | replaceChar}}
              </td>
              <td></td>
              <td>
                <!-- <img src="assets/img/dashboard/doc.png"> -->
                <i class="fa fa-phone cursor-pointer" (click)="callToLead(data.lead_details.contact)" style="    font-size: 1.5rem; color: #8F0020;"></i>
                
              </td>
          </tr>
        </tbody>
      </table>
      <div class="text-center" *ngIf="usersList && usersList.length >0">
        <pagination-controls autoHide="true" (pageChange)="current_page = getUserListForDesigner($event)"></pagination-controls>
      </div>
    </div>
  </div>
</div>

<div class="row my-4 mobView">
  <div class="col-12">
    <div  *ngFor="let data of usersList; let i = index; " [attr.data-index]="i" id="filteredLeadRow{{i}}">
      <div class="card card-body mobCard mb-2">
        <a data-toggle="collapse" href="#tableDiv{{i}}"><i class="fa fa-angle-right"></i></a>
        <h4 class="ss-link cursor-pointer" routerLink="/lead/{{data.id}}/activity-logs">Name: {{data.name}}</h4>
        <div class="row">
          <p class="col-5 mb-0" *ngIf="data.lead_details!=null">LEAD ID: {{data.lead_details.id}}</p>
          <h6 class="col-7 mb-0">
            <ng-container *ngIf="(data.project_details.status!='follow_up' && data.project_details.status!='lost')">Status: {{data.project_details.status | replaceChar}} 
            </ng-container>
            <ng-container *ngIf="(data.project_details.status=='follow_up')">
                <a data-trigger="hover" title="Remarks" [attr.data-content] ="data.project_details.remarks" class="pop" (mouseenter)="openpopup($event)">{{data.project_details.status | replaceChar}}</a>
                <p class="time-chng">Status: {{data.event_scheduled_at.follow_up | date:'dd/MM/yyyy - h:mm a'}}</p>
            </ng-container>
            <ng-container *ngIf="(data.project_details.status=='lost')">
                <a data-trigger="hover" title="Remarks" [attr.data-content] ="data.project_details.reason_for_lost | replaceChar " class="pop" (mouseenter)="openpopup($event)">Status: {{data.project_details.status | replaceChar}}</a>
            </ng-container>
          </h6>
        </div>
      </div>
      <div class="collapse" id="tableDiv{{i}}">
        <div class="card card-body py-0 mb-3">
          <div class="row">
            <div class="col-6 py-3 borderRight">
              <p class="tableInner">ASSIGNMENT DATE</p>
              <p class="tableInner">{{data.designer_assignement_date | date: 'dd/MM/yyyy - h:mm a'}}</p>
            </div>
            <div class="col-6 py-3">
              <p class="tableInner">Change Status</p>
              <select (change) = "onStatusChange(data.project_details.user_id, $event.target.value)" class="custom-select" >
                <option>Change Status</option>
                <option value="lost" >Lost</option>
                <option value="not_contactable" >Not Contactable</option>
                <option value="follow_up" >Follow Up</option>
                <option value="wip" >WIP</option>
              </select>
            </div>
            <div class="col-12 callBtn" (click)="callToLead(data.lead_details.contact)">
              <span>CALL</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- customers table ends-->

<!--sms modal start-->
<div class="modal fade" id="SmsModal" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog mobModal" role="document" style="width: 55rem;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Send SMS</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="sendSmsForm" (ngSubmit)="sendSmsSubmitForm(sendSmsForm.value); sendSmsForm.reset();">
          <textarea rows="3" formControlName="sms_body" class="form-control"></textarea>
          <button type="submit" class="openDesignToolBtn" style="float: right;margin-top: 12px;">Send SMS</button>
        </form>
      </div>
    </div>
  </div>
</div>
<!--sms modal ends-->

<!-- details modal start-->
<div class="modal fade" id="leadDetailsModal" tabindex="-1" role="dialog" aria-labelledby="leadDetailsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
          <div class="modal-header">
            <div class="btnGroup">
                <button class="upload0 actBtn" (click)="basicDetails()">Basic Details</button>
                <button class="upload1" (click)="projectDetails()">Project Details</button>
                <button class="upload3" (click)="userStatus()">Change Status</button>
                <button class="upload2"  (click)="questionnaire(); getUserQuestionnaireDetails(leadIdForModal)">CS Questionnaire</button>
                <button class="upload4"  (click)="designerquestionnaire1(); getDesignerBookingForm(projectDetailsForModal.id)">Booking Form 1</button>
                <button class="upload5"  (click)="designerquestionnaire2(); getDesignerBookingForm(projectDetailsForModal.id)">Booking Form 2</button>
            </div>
            <h5 class="modal-title v-title mt-5 addClass" id="exampleModalLabel">Basic Details</h5>
            <h5 class="modal-title v-title mt-5 addClass1 hideClass" id="exampleModalLabel">Project Details</h5>
            <h5 class="modal-title v-title mt-5 addClass3 hideClass" id="exampleModalLabel">Change Status</h5>
            <h5 class="modal-title v-title mt-5 addClass2 hideClass" id="exampleModalLabel">CS Questionnaire</h5>
            <h5 class="modal-title v-title mt-5 addClass4 hideClass" id="exampleModalLabel">Booking Form 1</h5>
            <h5 class="modal-title v-title mt-5 addClass5 hideClass" id="exampleModalLabel">Booking Form 2</h5>
            <button type="button" class="close close1" data-dismiss="modal" aria-label="Close">
                <img class="close" (click)="closeModal()" data-dismiss="modal" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
            </button>
          </div>
          <div class="modal-body leadView">
            <div class="col-12" *ngIf="successalert">
                <div class="alert-box grid-100" *ngIf="successMessage">
                  <div class="alert alert-success mt-3 text-center">
                      <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
                      {{successMessage}}
                    </div>
                </div>
              </div>
            <div class="row addClass" *ngIf="customerDetails">
              <div class="col-sm-12 col-md-11">
                <div class="row">
                  <div class="col-lg-9">
                    <div class="topSpace"> 
                      <form class="viewProfileForm">
                          <div class="row">
                            <div class="col-2 mb-4">
                              <label class="productLabel"><strong>Name:</strong></label>
                            </div>
                            <div class="col-10 mb-4">
                              <input type="text" class="form-control productInput" placeholder=" {{customerDetails.name | ucwords}}" readonly/>
                            </div>
                            <div class="col-2 mb-4">
                              <label class="productLabel"><strong>Email:</strong></label>
                            </div>
                            <div class="col-10 mb-4">
                              <input type="text" class="form-control productInput" placeholder="{{customerDetails.email}}" readonly/>
                            </div>
                            <!-- <div class="col-2 mb-4">
                              <label class="productLabel"><strong>Contact:</strong></label>
                            </div> -->
                            <!-- <div class="col-10 mb-4">
                                <input type="text" class="form-control productInput"
                                     placeholder="{{customerDetails.contact != '' && customerDetails.contact != null && customerDetails.contact || 'NA'}}" readonly/>
                            </div> -->
                            <div class="col-2 mb-4">
                              <label class="productLabel"><strong>Pin code:</strong></label>
                            </div>
                            <div class="col-10 mb-4">
                              <input type="text" class="form-control productInput"
                                     placeholder="{{customerDetails.pincode != '' && customerDetails.pincode != null && customerDetails.pincode || 'NA'}}" readonly/>
                            </div>
                            <div class="col-2 mb-4">
                              <label class="productLabel"><strong>Created Date:</strong></label>
                            </div>
                            <div class="col-10 mb-4">
                                <input type="text" class="form-control productInput"  
                                     placeholder="{{customerDetails.created_at | date:'dd/MM/yyyy @ h:mma'}}" readonly/>
                            </div>
                            <div class="col-2 mb-4">
                              <label class="productLabel"><strong>GST Number:</strong></label>
                            </div>
                            <div class="col-10 mb-4">
                                <input type="text" class="form-control productInput"
                                     placeholder="{{customerDetails.gst_number != '' && customerDetails.gst_number != null && customerDetails.gst_number || 'NA'}}" readonly/>
                            </div>
                            <div class="col-2 mb-4">
                              <label class="productLabel"><strong>PAN:</strong></label>
                            </div>
                            <div class="col-10 mb-4">
                                <input type="text" class="form-control productInput"
                                     placeholder="{{customerDetails.pan != '' && customerDetails.pan != null && customerDetails.pan || 'NA'}}" readonly/>
                            </div>
                            <div class="col-2 mb-4">
                              <label class="productLabel"><strong>Address Proof:</strong></label>
                            </div>
                            <div class="col-10 mb-4">
                              <a href="{{customerDetails.address_proof}}" *ngIf="!(customerDetails.address_proof_content_type == 'image/png' || customerDetails.address_proof_content_type == 'image/jpg' || customerDetails.address_proof_content_type == 'image/jpeg' || customerDetails.address_proof_content_type == 'image/svg' || customerDetails.address_proof_content_type == null) && (customerDetails.address_proof != '/images/original/missing.png')">Download Address Proof</a>
                              <a href="{{customerDetails.address_proof}}" *ngIf="(customerDetails.address_proof_content_type == 'image/png' || customerDetails.address_proof_content_type == 'image/jpg' || customerDetails.address_proof_content_type == 'image/jpeg' || customerDetails.address_proof_content_type == 'image/svg' || customerDetails.address_proof_content_type == null) && (customerDetails.address_proof != '/images/original/missing.png') ">Download Address Proof</a>
                              <input type="text" class="form-control productInput" placeholder="NA" *ngIf="customerDetails.address_proof == '/images/original/missing.png'" readonly/>
                            </div>
                          </div>
                      </form>
                </div>
              </div>
              <div class="col-lg-3 text-center mt-5 topSpace">
                    <img src="{{customerDetails.avatar}}" height="170px" width="170px" class="profileImg" *ngIf="customerDetails.avatar != '/images/original/missing.png'">
                    <img *ngIf="customerDetails.avatar == '/images/original/missing.png'" height="170px" width="170px" class="profileImg"
                       src="assets/v3/img/profile.jpeg">
                    <p *ngIf="profile">{{customerDetails.roles[0] | replaceChar | ucwords }}</p>
                  </div>
            </div>
          </div>
            </div>
            <div class="row addClass1 hideClass" *ngIf="customerDetails">
          <div class="col-sm-12 col-md-11">
            <div class="row">
              <div class="col-lg-12">
                <div class="topSpace"> 
                  <form class="viewProfileForm">
                    <div class="container">
                      <div class="row">
                        <div class="col-2 mb-4">
                          <label class="productLabel"><strong>Name:</strong></label>
                        </div>
                        <div class="col-10 mb-4">
                          <input type="text" class="form-control productInput"
                                     placeholder="{{projectDetailsForModal.name != '' && projectDetailsForModal.name != null && projectDetailsForModal.name || 'NA'}}" readonly/>
                        </div>
                        <div class="col-2 mb-4">
                          <label class="productLabel"><strong>Details:</strong></label>
                        </div>
                        <div class="col-10 mb-4">
                          <textarea class="form-control productInput"
                                     placeholder="{{projectDetailsForModal.details != '' && projectDetailsForModal.details != null && projectDetailsForModal.details || 'NA'}}" readonly rows="2"></textarea>
                         <!--  <input type="text" class="form-control productInput"
                                     placeholder="{{projectDetailsForModal.details != '' && projectDetailsForModal.details != null && projectDetailsForModal.details || 'NA'}}" readonly/> -->
                        </div>
                        <div class="col-2 mb-4">
                          <label class="productLabel"><strong>Created Date:</strong></label>
                        </div>
                        <div class="col-10 mb-4">
                          <input type="text" class="form-control productInput"
                                   placeholder="{{projectDetailsForModal.created_at |date:'dd/MM/yyyy @ h:mma'}}" readonly/>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row addClass2 hideClass" *ngIf="customerDetails">
          <div class="col-sm-12 col-md-12">
            <div class="row">
              <div class="col-lg-12">
                <div class="topSpace"> 
                  <p  class="text-center my-5" style="font-size: 18px;" *ngIf="customerDetails.lead_questionnaire == null">No Questionnaire filled for this user</p>
                  <form [formGroup]="leadquestionnaire" *ngIf="customerDetails.lead_questionnaire!= null">
                      <div  class="row question">
                        <div class="col-md-6 mt-3">
                            <label class="customLabel"><strong>Customer Name:</strong></label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.customer_name}}" formControlName="customer_name" readonly>
                        </div>

                        <div class="col-md-6 mt-3">
                            <label class="customLabel"><strong>Customer Phone No:</strong></label>
                        <input type="number" class="form-control" placeholder="{{customerDetails.lead_questionnaire.phone}}" formControlName="phone" readonly>
                        </div>
                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>Project Name:</strong></label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.project_name}}" formControlName="project_name" readonly>
                        </div>

                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>City:</strong></label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.city}}" formControlName="city" readonly>
                        </div>
                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>Location:</strong></label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.location}}" formControlName="location" readonly>
                        </div>

                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>Project Type:</strong></label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.project_type}}" formControlName="project_type" readonly>
                        </div>
                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>Type of Accommodation:</strong> </label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.accomodation_type}}" formControlName="accomodation_type" readonly>
                        </div>

                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>Scope of work</strong></label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.scope_of_work}}" formControlName="scope_of_work" readonly>
                        </div>
                        <div class="col-md-6 mt-4" *ngIf="customerDetails.lead_questionnaire.remarks_of_sow">
                            <label class="customLabel"><strong>Remarks (Scope of work)</strong></label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.remarks_of_sow}}" formControlName="scope_of_work" readonly>
                        </div>
                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>Possession status:</strong> </label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.possession_status}}" formControlName="possession_status" readonly>
                        </div>
                        <div class="col-md-6 mt-4" *ngIf="customerDetails.lead_questionnaire.possession_status_date && customerDetails.lead_questionnaire.possession_status!='Possession Taken' ">
                            <label class="customLabel"><strong>Select Possession Month and Year </strong></label>
                            <input class="form-control" type="text" formControlName="possession_status_date" readonly placeholder="{{customerDetails.lead_questionnaire.possession_status_date}}">
                        </div>

                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>Do you have a home loan against the property?</strong> </label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.have_homeloan}}" formControlName="have_homeloan" readonly>
                        </div>
                        <div class="col-md-6 mt-4">
                          <label class="customLabel"><strong>Home Value(In Rs. Lacs)</strong></label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.home_value}}" formControlName="home_value" readonly>
                        </div>

                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>Budget Value(In Rs. Lacs)</strong> </label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.budget_value}}" formControlName="budget_value" readonly>
                        </div>
                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>Call Back Day:</strong> </label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.call_back_day}}" formControlName="call_back_day" readonly>
                        </div>

                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>Call Back Time:</strong> </label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.call_back_time}}" formControlName="call_back_time" readonly>
                        </div>
                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>Do you have a floor plan?</strong> </label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.have_floorplan}}" formControlName="have_floorplan" readonly>
                        </div>
                        <div class="col-md-6 mt-4" *ngIf="customerDetails.lead_questionnaire.lead_floorplan_url != '/images/original/missing.png' && customerDetails.lead_questionnaire.have_floorplan=='Yes'">
                            <label class="customLabel"><strong>Uploaded Floorplan</strong> </label><br>
                            <a href="{{customerDetails.lead_questionnaire.lead_floorplan_url}}" target="_blank"  style="color: #007bff">View Floorplan </a>
                        </div>
                        <div class="col-md-6 mt-4" *ngIf="customerDetails.lead_questionnaire.lead_floorplan_url == '/images/original/missing.png' && customerDetails.lead_questionnaire.have_floorplan=='Yes'">
                            <label class="customLabel"><strong>Uploaded Floorplan</strong> </label><br>
                            <span class="text-danger">Floorplan not available </span>
                        </div>
                        <div class="col-md-6 mt-4">
                            <label class="customLabel"><strong>Additional Comments:</strong> </label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.additional_comments}}" formControlName="additional_comments" readonly>
                        </div>
                        <!-- <div class="col-md-12 mt-4 ml-0">
                            <div class="form-group col-md-12">
                                <button type="button" class="btn btn-pink addCursor" (click)="addAlternateNumberForm()">Add Alternate Number Designer </button>
                            </div>
                            <div *ngIf="showAlternateForm">
                            <div *ngFor="let field of fields" class="col-6 d-inline-block mb-3">
                                <app-dynamic-form [field]="field" [form]="alternateNumberForm"></app-dynamic-form>
                            </div>
                          </div>
                          </div> -->

                       <!--  <div class="col">
                            <label class="customLabel"><strong>Lead Generator:</strong> </label>
                            <input type="text" class="form-control" placeholder="{{customerDetails.lead_questionnaire.lead_generator}}" formControlName="lead_generator" readonly>
                        </div> -->
                      </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row addClass3 hideClass" *ngIf="customerDetails">
          <div class="col-sm-12 col-md-12">
            <div class="row">
              <div class="col-lg-12">
                <div class="topSpace"> 
                  <form class="" [formGroup]="customerStatusUpdateForm">
                    <div class="container">
                      <div class="row">
                        <div class="col-6">
                          <label><strong>Select Status</strong></label>
                              <select class="form-control" (change)="setUserStatus($event.target.value)" formControlName="customer_status">
                                <option value="" disabled>Select Status</option>
                                <option value="meeting_fixed">Meeting Fixed</option>
                                <option value="follow_up">Follow Up</option>
                                <option value="lost">Lost</option>
                                <option value="not_contactable">Not Contactable</option>
                              </select>
                        </div>
                        <div class="col-6" id="followupdatetime" style="display: none;">
                          <div class="form-group">
                              <label><strong>Follow up time:</strong></label>
                              <!-- <input class="form-control" type="datetime-local" formControlName="customer_meeting_time"> -->
                              <input [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" placeholder="Enter Date & Time" formControlName="customer_meeting_time" class="form-control">
                                <owl-date-time #dt2 ></owl-date-time>
                          </div>
                        </div>
                        <div class="col-6" style="display: none;" id="lostremark">
                           <div class="form-group">
                             <label ><strong>Remarks:</strong></label>
                              <textarea class="form-control" rows="2" formControlName="customer_remarks"></textarea>
                          </div>
                        </div>
                        <div class="col-6" id="meetingdatetime" style="display: none;">
                          <div class="form-group">
                              <label><strong>Meeting time</strong> </label>
                             <!--  <input class="form-control" type="datetime-local" formControlName="customer_meeting_time"> -->

                              <input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="Enter Date & Time" formControlName="customer_meeting_time" class="form-control">
                                <owl-date-time #dt1></owl-date-time>
                          </div>
                        </div>
                      </div>
                      <div align="right" style="margin-top: 10px;">
                          <button class="btn btn-dark addCursor" type="submit" (click)="updateStatus(customerStatusUpdateForm.value)" [disabled]="!customerStatusUpdateForm.valid">Update</button>
                      </div>  
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row addClass4 hideClass" *ngIf="customerDetails">
            <div class="col-sm-12 col-md-12">
              <div class="row">
                  <div class="col-lg-12">
                    <div class="topSpace"> 
                        <form [formGroup]="designerBookingForm1" (ngSubmit)="designerBookingForm1Submit(designerBookingForm1.value,'bookingForm1')">
                          <div  class="row question" *ngIf="bookingFormDetails">
                            <div class="col-md-6 mt-3">
                                <label class="customLabel"><strong>Customer Name </strong></label>
                                <input type="text" class="form-control" placeholder="{{customerDetails.name}}" formControlName="customer_name" readonly>
                            </div>
                            <div class="col-md-6 mt-3">
                                <label class="customLabel"><strong>Customer Age </strong></label>
                              <input type="text" class="form-control" placeholder="" formControlName="customer_age">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Profession / Background of the Client </strong></label>
                                <input type="text" class="form-control" placeholder=""  formControlName="profession">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Family Background of members staying in the house </strong></label>
                                <input type="text" class="form-control" formControlName="family_profession" placeholder="">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Age of the house or structure of the house/area which needs to be remodelled or refurbish</strong></label>
                                <input type="text" class="form-control" formControlName="age_house" placeholder="">
                            </div>

                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Lifestyle of the members staying in the house</strong></label>
                                <input type="text" class="form-control" formControlName="lifestyle" placeholder="">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>What do they love about the house or a particular area in the house. (e.g. Warm corners, Cozy corner, Family space, Activity space)</strong> </label>
                                <input type="text" class="form-control" formControlName="house_positive_features" placeholder="">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Something which they don’t like in the house or a particular area. (Negative space, Passage areas, No ventilation)</strong></label>
                                <input type="text" formControlName="house_negative_features" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Any inspirational references they have in their mind which they want to duplicate </strong></label>
                                <input type="text" formControlName="inspiration" class="form-control col-md-7" style="display: inline;">
                                <input class="form-control col-md-4" type="file" (change)="onChange($event)" name="attachment_file" ngModel #attachment_file="ngModel" [ngModelOptions]="{standalone: true}" style="display: inline;"><br>
                                <a href="{{bookingFormDetails.designer_booking_form.general.inspiration_image}}" *ngIf="bookingFormDetails && bookingFormDetails.designer_booking_form.general.inspiration_image!='/images/original/missing.png'" target="_blank">View Reference</a>
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Any preferred colour tones/hues/shades or antiques, or decor</strong> </label>
                                <input type="text" formControlName="color_tones" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                              <label class="customLabel"><strong>Is there any particular theme which interests you for the look of the place? </strong></label>
                              <input class="form-control" formControlName="theme" type="text">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>How do they use this house/room (Functionality of the house, Will they lease it out Or Occupy it themselves)?</strong> </label>
                                <input type="text" formControlName="functionality" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                              <label class="customLabel"><strong> Do you need  a false ceiling for the space?</strong></label>
                                <input type="text" formControlName="false_ceiling" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Will there be changes in electrical points, adding new ones like changing the TV point?</strong> </label>
                                <input type="text" formControlName="electrical_points" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Are there any special needs/wants that I as a designer should take into consideration?</strong> </label>
                                <input type="text" formControlName="special_needs" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Do you want to consider Vastu Shastra  in your design, and what are the things that you want to consider into it?</strong> </label>
                                <input type="text" formControlName="vastu_shastra" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Do they want to accomplish this all at once or in phases(May be first just the living area / Only kitchen / Only furniture works etc)</strong> </label>
                                <input type="text" formControlName="all_at_once" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Any budget range they have set in their mind (Approximate ball park figure and range)</strong> </label>
                                <input type="text" formControlName="budget_range" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Any particular design style in accordance to their tastes(Contemporary,  Modern,  Elegant, Royal, Traditional Or Ethnic styles)</strong> </label>
                                <input type="text" formControlName="design_style_tastes" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Do they want more of storage space in the house, where, and what do they want to store?</strong> </label>
                                <input type="text" formControlName="storage_space" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>How do they want the mood of the house to be created. (Formal, Relaxed, Warm, Cool, Lively, Spacious etc)?</strong> </label>
                                <input type="text" formControlName="mood" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>What are the enhancements which needs to be considered like furniture, flooring, re-upholstery, remodelling, space planning, wall & floor coverings, lighting etc?</strong> </label>
                                <input type="text" formControlName="enhancements" class="form-control">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Will they like to come to our experience centre, to discuss the details in person?</strong> </label>
                                <input type="text" formControlName="discuss_in_person" class="form-control">
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12 mt-4">
                              <button class="button_emi button" id="designerBookingForm1Button">SUBMIT</button>
                            </div>
                          </div>
                        </form>
                    </div>
                  </div>
              </div>
            </div>
        </div>
        <div class="row addClass5 hideClass" *ngIf="customerDetails">
            <div class="col-sm-12 col-md-12">
              <div class="row">
                  <div class="col-lg-12">
                    <div class="topSpace">
                        <form [formGroup]="designerBookingForm1" (ngSubmit)="designerBookingForm1Submit(designerBookingForm1.value,'bookingForm2')">
                          <div  class="row question" *ngIf="bookingFormDetails">
                            <div class="col-md-6 mt-3">
                                <label class="customLabel"><strong>Customer Name </strong></label>
                                <input type="text" class="form-control" placeholder="{{customerDetails.name}}" readonly formControlName="customer_name">
                            </div>
                            <div class="col-md-6 mt-3">
                                <label class="customLabel"><strong>Customer Age </strong></label>
                              <input type="text" class="form-control" placeholder="" formControlName="customer_age">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Profession / Background of the Client </strong></label>
                                <input type="text" class="form-control" placeholder="" formControlName="profession">
                            </div>

                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Family Background of members staying in the house </strong></label>
                                <input type="text" class="form-control" placeholder="" formControlName="family_profession">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>How old is the kitchen</strong></label>
                                <input type="text" class="form-control" placeholder="" formControlName="mk_age">
                            </div>

                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Lifestyle of the members staying in the house</strong></label>
                                <input type="text" class="form-control" placeholder="" formControlName="mk_lifestyle">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Are they planning to gut the kitchen area</strong> </label>
                                <input type="text" class="form-control" placeholder="" formControlName="mk_gut_kitchen">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Are they planning to keep the same layout & simply make cosmetic changes</strong></label>
                                <input type="text" class="form-control" formControlName="mk_same_layout">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>What kind of improvements are they looking for in a new kitchen (Upgraded electrical service, Better lighting, Additional storage space. ) </strong></label>
                                <input type="text" class="form-control" formControlName="mk_improvements">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Some special requirements in a new kitchen?</strong> </label>
                                <input type="text" class="form-control" formControlName="mk_special_requirements">
                            </div>
                            <div class="col-md-12 mt-4">
                              <label class="customLabel"><strong>Who is the primary cook? And what kind of cooking they have on a regular basis (Veg / Non Veg) </strong></label>
                              <input class="form-control" type="text" formControlName="mk_cooking_details">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>List of appliances/white goods/smaller electrical appliances(Microwave / Oven / Mixie)</strong> </label>
                                <input type="text" class="form-control" formControlName="mk_appliances">
                            </div>
                            <div class="col-md-12 mt-4">
                              <label class="customLabel"><strong> What is the family eating area as in  like kitchen area, dining table, counter space?</strong></label>
                                <input type="text" class="form-control" formControlName="mk_family_eating_area">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>How often do they entertain guests?</strong> </label>
                                <input type="text" class="form-control" formControlName="mk_guest_frequence">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Storage patterns like monthly, yearly, as required basis?</strong> </label>
                                <input type="text" class="form-control" formControlName="mk_storage_patterns">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>What kind of cabinets facing they are looking at (Glossy / Matt)</strong> </label>
                                <input type="text" class="form-control" formControlName="mk_cabinet_finishing">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Counter top material/backsplash materials to be discussed</strong> </label>
                                <input type="text" class="form-control" formControlName="mk_countertop_materials">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label class="customLabel"><strong>Any colour/mood for the look preferred?</strong> </label>
                                <input type="text" class="form-control" formControlName="mk_mood">
                            </div> 
                          </div>
                          <div class="row">
                            <div class="col-md-12 mt-4">
                              <button class="button_emi button" id="designerBookingForm2Button">SUBMIT</button>
                            </div>
                          </div>
                        </form>
                    </div>
                  </div>
              </div>
            </div>
        </div>
          </div>
      </div>
    </div>
</div>
<!-- details modal end-->

<!-- Status modal -->
<div class="modal fade" id="statusModal" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg mobModal" role="document" style="width: 55rem;margin-top: 55px;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Follow-up Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <img class="close" data-dismiss="modal" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
    </button>
      </div>
      <div class="modal-body">

        <div class="form-group row">
          <label for="example-text-input" class="col-2 col-form-label">Callback Date</label>
          <div class="col-10">
            <input type="datetime-local" name="followup-details" id="followup-details" class="form-control" (change) = "disableDate()">
          </div>
        </div>
        <div class="form-group row">
          <label for="example-text-input" class="col-2 col-form-label">Remarks </label>
          <div class="col-10">
            <textarea rows="1" name="followup_remarks" id="followup_remarks" class="form-control"></textarea>
            <!-- <input type="da" name="followup-details" id="followup-details" class="form-control"> -->
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <input type="button" id="followup-button" value="Update" class="btn btn-pink" (click) = "onCallbackChange('follow_up')" >
      </div>
    </div>
  </div>
</div>
<!-- Status modal end -->


<div class="modal fade" id="loststatusModal" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg mobModal" role="document" style="width: 55rem;">
    <form [formGroup]="statusChangeForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5>Lost Details</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img class="close" data-dismiss="modal" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
          </button>
        </div>
        <div class="modal-body">

          <div class="form-group row">
            <label for="example-text-input" class="col-3 col-form-label">Reason for Lost <span class="text-danger">*</span></label>
            <div class="col-9">
              <select class="form-control" id="lost_reason" formControlName="reson_for_lost" (change)="reasonForLostDropdownChange($event.target.value)">
                <option value="" disabled>Select Reason</option>
                <option value="not_in_scope">Not in Scope</option>
                <option value="low_budget">Low Budget</option>
                <option value="out_of_area">Out of Area</option>
                <option value="not_interested">Not Interested</option>
                <option value="already_done_with_other_vendor">Already done with Other Vendor</option>
                <option value="others">Others </option>
              </select>
            </div>
          </div>
          <div class="form-group row" id="lostRemarkRow">
            <label for="example-text-input" class="col-3 col-form-label">Remarks <span class="text-danger">*</span> </label>
            <div class="col-9">
              <textarea rows="1" name="lost_remarks" id="lost_remarks" class="form-control" formControlName="lost_remarks"></textarea>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <input type="button" id="lost-button" value="Update" class="btn btn-pink addCursor" (click) = "onCallbackChange('lost')" [disabled]="!statusChangeForm.valid">
        </div>
      </div>
    </form>
  </div>
</div>


<!-- Not Conatcatable Modal Box -->
<div class="modal fade" id="notContactableModal" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg mobModal" role="document" style="width: 55rem;margin-top: 55px;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Not Contactable</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <img class="close" data-dismiss="modal" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
    </button>
      </div>
      <div class="modal-body">

        <div class="form-group row">
          <label for="example-text-input" class="col-2 col-form-label">Callback Date</label>
          <div class="col-10">
            <input type="datetime-local" name="notcontactable-details" id="notcontactable-details" class="form-control" (change) = "disableDate()">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <input type="button" id="followup-button" value="Update" class="btn btn-pink" (click) = "onCallbackChange('not_contactable')" >
      </div>
    </div>
  </div>
</div>


<!-- Ends here -->
<!-- DELAYED MODAL starts here -->
<div class="modal fade" id="delayedModal" tabindex="-1" role="dialog" aria-labelledby="dropLeadTitle" aria-hidden="true">
  <div class="modal-dialog modal-md" role="document" style="width: 55rem;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>DELAYED POSSESION DATE</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <img class="close" data-dismiss="modal" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group row">
          <label for="example-text-input" class="col-4 col-form-label">Delayed Possesion Date</label>
          <div class="col-md-8">
            <input name="startDate" id="startDate" class="date-picker" (focus)="callChangeNew()" placeholder="Choose A Month..."/>
            
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <input type="button"  value="Submit" class="btn btn-pink" (click) = "onCallbackChangeForDelay()" >
      </div>
    </div>
  </div>
</div>

<!-- END HERE -->
<!-- DELAYED PROJECT MODAL starts here -->
<div class="modal fade" id="delayedProjectModal" tabindex="-1" role="dialog" aria-labelledby="dropLeadTitle" aria-hidden="true">
  <div class="modal-dialog modal-md" role="document" style="width: 55rem;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>DELAYED PROJECT DATE</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <img class="close" data-dismiss="modal" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group row">
          <label for="example-text-input" class="col-4 col-form-label">Delayed Project Date</label>
          <div class="col-md-8">
            <input name="startDate" id="delayProjectDate" class="date-picker" (focus)="callChangeNew()" placeholder="Choose A Month..."/>
            
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <input type="button"  value="Submit" class="btn btn-pink" (click) = "onCallbackChangeForDelayProject()" >
      </div>
    </div>
  </div>
</div>

<!-- END HERE -->


<!--Smart Share History modal-->
<div class="modal fade" id="smartShareHistory" tabindex="-1" role="dialog" aria-labelledby="smartShareHistory" aria-hidden="true">
  <div class="modal-dialog modal-lg mobModal" role="document" style="width: 55rem;margin-top: 55px;">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <img class="close" data-dismiss="modal" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
        </button>
      </div>
      <div class="modal-body overFlowY">
        <div *ngIf="this.smartshareHistoryList!=0">
          <table class="table table-striped">
            <tr>
              <th>Click Url of the SmartShare</th>
              <th>Time of Sharing</th>
            </tr>

            <tr *ngFor="let elem of smartshareHistoryList">
              <td><a  href="{{elem.url}}" target="blank">{{elem.url}}</a></td>
              <td>{{elem.time_stamp}}</td>
            </tr>
          </table>
        </div>

        <div *ngIf="this.smartshareHistoryList==0">
          <div class="boq-img  col-lg-12">
            <div class="row">
              <div class="col-lg-6 mx-auto">
                <img class="ml-4" src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
              </div>
            </div>
          </div>
          <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Ends here -->






// WEBPACK FOOTER //
// ./src/app/platform/designer/lead-details-for-designer/lead-details-for-designer.component.html